import { AppHealthPage } from './AppHealthPage'

export const VisualMind = () => {
  return <AppHealthPage appName="visualmind" displayName="Visual Mind" />
}

export default VisualMind
